import { IApp04TopicUser } from '../types';
import { EntityService } from './EntityService';

export class App04TopicUserService extends EntityService<IApp04TopicUser> {
    constructor() {
        super(`/App04TopicUsers`);
    }
}